import { z } from 'zod'
import { zId, zIdNullable, zIsoDate } from '../common'

// The actor that performed the action. System-triggered events may omit it.
export const zAuditLogActor = z
  .object({
    id: zId,
    email: z.string(),
  })
  .passthrough()
export type AuditLogActor = z.infer<typeof zAuditLogActor>

// Confirmed against the real API:
//   { id, action, resourceType, resourceId, adminUser: { id, email },
//     metadata: { …snake_case snapshot… }, createdAt }
// `metadata` mirrors the affected record and keeps its jsonb snake_case.
export const zAuditLog = z
  .object({
    id: zId,
    action: z.string(),
    resourceType: z.string(),
    resourceId: zIdNullable,
    adminUser: zAuditLogActor.nullable(),
    metadata: z.record(z.unknown()).nullable(),
    createdAt: zIsoDate,
  })
  .passthrough()
export type AuditLog = z.infer<typeof zAuditLog>
